import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 24px;
  /* Espaço para a barra flutuante da cesta não cobrir o fim da tabela. */
  padding-bottom: 96px;

  .print-only {
    display: none;
  }

  .results-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;

    .results-actions .btn {
      display: inline-flex;
      align-items: center;
      gap: 4px;

      i {
        font-size: 16px;
      }
    }

    .results-title {
      margin: 0;
      font-size: 1.05rem;
      font-weight: 700;
      color: ${(props) => props.theme.$gray900};
    }

    .results-sub {
      margin: 2px 0 0;
      font-size: 0.85rem;
      color: ${(props) => props.theme.$gray600};
    }
  }

  .curation-chip {
    display: inline-flex;
    align-items: flex-start;
    gap: 8px;
    margin-top: 12px;
    padding: 10px 14px;
    border-radius: 10px;
    background: ${(props) => props.theme.$bg_green};
    border: 1px solid ${(props) => props.theme.$secondary_green_light};
    font-size: 0.85rem;
    color: ${(props) => props.theme.$gray800};
    max-width: 100%;

    i {
      font-size: 18px;
      color: ${(props) => props.theme.$primary_green};
      flex-shrink: 0;
      margin-top: 1px;
    }

    strong {
      font-weight: 700;
    }

    .curation-extra {
      display: flex;
      align-items: flex-start;
      gap: 4px;
      margin: 6px 0 0;
      font-size: 0.8rem;
      color: ${(props) => props.theme.$dark_green};

      i {
        font-size: 15px;
        margin-top: 1px;
      }
    }

    .curation-queries {
      display: flex;
      align-items: center;
      gap: 6px;
      flex-wrap: wrap;
      margin-top: 8px;

      > span:first-child {
        font-size: 0.7rem;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        color: ${(props) => props.theme.$gray500};
      }

      .query-chip {
        padding: 1px 8px;
        border-radius: 6px;
        background: #fff;
        border: 1px solid ${(props) => props.theme.$secondary_green_light};
        font-size: 0.76rem;
        color: ${(props) => props.theme.$gray700};
      }
    }
  }

  .callout {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-top: 12px;
    padding: 10px 14px;
    border-radius: 10px;
    border: 1px solid ${(props) => props.theme.$gray300};
    font-size: 0.86rem;
    color: ${(props) => props.theme.$gray800};

    > i {
      font-size: 20px;
      flex-shrink: 0;
    }

    > div,
    > p {
      flex: 1 1 260px;
      min-width: 0;
    }

    p {
      margin: 0;
    }

    &.success {
      background: ${(props) => props.theme.$bg_green};
      border-color: ${(props) => props.theme.$secondary_green_light};

      > i {
        color: ${(props) => props.theme.$primary_green};
      }
    }

    &.project {
      padding: 14px 16px;
      border-color: ${(props) => props.theme.$primary_green};
      background: linear-gradient(135deg, ${(props) => props.theme.$bg_green}, #ffffff 70%);

      > i {
        color: ${(props) => props.theme.$dark_green};
      }

      .callout-title {
        font-size: 0.98rem;
        font-weight: 700;
        color: ${(props) => props.theme.$dark_green};
      }

      .callout-sub {
        margin-top: 2px;
        font-size: 0.8rem;
        color: ${(props) => props.theme.$gray600};
      }
    }

    &.warning {
      align-items: center;
      flex-wrap: wrap;
      background: ${(props) => props.theme.$warning_light_bg};
      border-color: #f1dca0;

      > i {
        color: ${(props) => props.theme.$gold};
      }
    }

    &.info {
      background: ${(props) => props.theme.$primary_light};
      border-color: ${(props) => props.theme.$primary_medium};

      > i {
        color: ${(props) => props.theme.$primary};
      }
    }
  }

  .alerts {
    margin-top: 12px;

    .alert {
      padding: 10px 14px;
      font-size: 0.85rem;
      margin-bottom: 8px;

      strong {
        margin-right: 4px;
      }
    }
  }

  .stat-tiles {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 14px;
    margin-top: 16px;

    @media only screen and (max-width: 992px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media only screen and (max-width: 576px) {
      grid-template-columns: 1fr;
    }
  }

  .stat-tile {
    background: #fff;
    border: 1px solid ${(props) => props.theme.$gray300};
    border-radius: 10px;
    box-shadow: 0 2px 12px rgba(33, 53, 74, 0.06);
    padding: 16px;

    .stat-label {
      margin: 0;
      font-size: 0.78rem;
      color: ${(props) => props.theme.$gray600};
    }

    .stat-value {
      margin: 4px 0 0;
      font-size: 1.45rem;
      font-weight: 700;
      color: ${(props) => props.theme.$gray900};
      line-height: 1.15;
    }

    .stat-hint {
      margin: 4px 0 0;
      font-size: 0.74rem;
      color: ${(props) => props.theme.$gray500};
    }

    &.accent {
      border-color: ${(props) => props.theme.$primary_green};
      background: linear-gradient(135deg, ${(props) => props.theme.$bg_green}, #ffffff 70%);

      .stat-label {
        color: ${(props) => props.theme.$dark_green};
        font-weight: 700;
      }

      .stat-value {
        color: ${(props) => props.theme.$dark_green};
      }
    }
  }

  .competitive-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
    margin-top: 14px;

    @media only screen and (max-width: 992px) {
      grid-template-columns: 1fr;
    }
  }

  .competitive-card {
    background: #fff;
    border: 1px solid ${(props) => props.theme.$gray300};
    border-radius: 10px;
    box-shadow: 0 2px 12px rgba(33, 53, 74, 0.06);
    padding: 18px;

    .comp-title {
      display: flex;
      align-items: center;
      gap: 6px;
      margin: 0 0 2px;
      font-size: 0.92rem;
      font-weight: 700;
      color: ${(props) => props.theme.$gray900};

      i {
        font-size: 18px;
        color: ${(props) => props.theme.$primary_green};
      }
    }

    .comp-sub {
      margin: 0 0 12px;
      font-size: 0.78rem;
      color: ${(props) => props.theme.$gray600};
    }

    ul {
      margin: 0;
      padding: 0;

      &.expanded {
        max-height: 360px;
        overflow-y: auto;
        padding-right: 4px;
      }
    }

    .comp-more {
      padding: 6px 0 0;
      font-size: 0.8rem;
    }

    .comp-link {
      border: 0;
      background: transparent;
      padding: 0;
      text-align: left;
      color: ${(props) => props.theme.$primary};

      &:hover {
        text-decoration: underline;
      }
    }

    .comp-action {
      border: 0;
      background: transparent;
      padding: 2px;
      display: inline-flex;
      color: ${(props) => props.theme.$gray500};
      flex-shrink: 0;

      &:hover {
        color: ${(props) => props.theme.$primary};
      }

      i {
        font-size: 18px;
      }
    }

    li {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 8px 0;

      & + li {
        border-top: 1px solid ${(props) => props.theme.$gray200};
      }

      .comp-rank {
        width: 22px;
        height: 22px;
        border-radius: 50%;
        background: ${(props) => props.theme.$gray100};
        color: ${(props) => props.theme.$gray600};
        font-size: 0.72rem;
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
      }

      &:first-child .comp-rank {
        background: ${(props) => props.theme.$bg_green};
        color: ${(props) => props.theme.$dark_green};
      }

      .comp-name {
        flex: 1;
        min-width: 0;
        font-size: 0.86rem;
        color: ${(props) => props.theme.$gray800};
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        a {
          color: ${(props) => props.theme.$primary};

          &:hover {
            text-decoration: underline;
          }
        }

        .comp-place {
          font-size: 0.74rem;
          color: ${(props) => props.theme.$gray500};
        }
      }

      .comp-metric {
        text-align: right;
        flex-shrink: 0;
        font-variant-numeric: tabular-nums;

        .metric-main {
          font-size: 0.86rem;
          font-weight: 700;
          color: ${(props) => props.theme.$gray900};
        }

        .metric-sub {
          font-size: 0.72rem;
          color: ${(props) => props.theme.$gray500};
        }
      }
    }

    .comp-empty {
      font-size: 0.84rem;
      color: ${(props) => props.theme.$gray500};
      margin: 0;
    }
  }

  .charts-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 14px;
    margin-top: 14px;

    @media only screen and (max-width: 992px) {
      grid-template-columns: 1fr;
    }
  }

  .samples-card {
    background: #fff;
    border: 1px solid ${(props) => props.theme.$gray300};
    border-radius: 10px;
    box-shadow: 0 2px 12px rgba(33, 53, 74, 0.06);
    margin-top: 14px;

    .samples-head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      flex-wrap: wrap;
      padding: 16px 18px;
      border-bottom: 1px solid ${(props) => props.theme.$gray200};

      .samples-title {
        margin: 0;
        font-size: 0.95rem;
        font-weight: 700;
        color: ${(props) => props.theme.$gray900};
      }

      .samples-sub {
        margin: 2px 0 0;
        font-size: 0.78rem;
        color: ${(props) => props.theme.$gray600};
      }

      .samples-tools {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;
      }

      .view-toggle {
        display: inline-flex;
        border: 1px solid ${(props) => props.theme.$gray300};
        border-radius: 999px;
        overflow: hidden;

        button {
          border: 0;
          background: #fff;
          padding: 4px 12px;
          font-size: 0.8rem;
          color: ${(props) => props.theme.$gray600};

          & + button {
            border-left: 1px solid ${(props) => props.theme.$gray300};
          }

          &.active {
            background: ${(props) => props.theme.$bg_green};
            color: ${(props) => props.theme.$dark_green};
            font-weight: 700;
          }
        }
      }

      select.custom-select {
        width: auto;
        font-size: 0.84rem;
      }
    }

    .samples-footer {
      padding: 12px 18px;
      display: flex;
      justify-content: center;
      border-top: 1px solid ${(props) => props.theme.$gray200};
    }
  }

  .basket-bar {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 18px;
    z-index: 1050;
    background: #fff;
    border: 1px solid ${(props) => props.theme.$gray300};
    border-radius: 999px;
    box-shadow: 0 8px 28px rgba(33, 53, 74, 0.18);
    padding: 10px 12px 10px 20px;
    display: flex;
    align-items: center;
    gap: 8px 18px;
    flex-wrap: wrap;
    max-width: calc(100vw - 32px);

    .basket-count {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      font-size: 0.85rem;
      color: ${(props) => props.theme.$gray800};

      .count-pill {
        min-width: 30px;
        height: 30px;
        padding: 0 8px;
        border-radius: 999px;
        background: ${(props) => props.theme.$primary_green};
        color: #fff;
        font-weight: 700;
        font-size: 0.82rem;
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }
    }

    .basket-stats {
      display: inline-flex;
      align-items: baseline;
      gap: 14px;
      font-size: 0.82rem;
      color: ${(props) => props.theme.$gray600};
      font-variant-numeric: tabular-nums;

      strong {
        color: ${(props) => props.theme.$gray900};
      }
    }

    .basket-actions {
      display: inline-flex;
      align-items: center;
      gap: 8px;

      .btn-ia {
        color: #fff;
        font-weight: 500;
        border-radius: 999px;
        display: inline-flex;
        align-items: center;
        gap: 5px;

        i {
          font-size: 17px;
        }
      }

      .btn-outline-secondary {
        border-radius: 999px;
        display: inline-flex;
        align-items: center;
        gap: 5px;

        i {
          font-size: 16px;
        }
      }
    }

    @media only screen and (max-width: 768px) {
      border-radius: 14px;
      bottom: 8px;
    }
  }

  @media print {
    padding-bottom: 0;

    .print-only {
      display: block;
      margin: 0 0 8px;
      font-size: 0.8rem;
      color: ${(props) => props.theme.$gray600};
    }

    .basket-bar,
    .samples-footer,
    .samples-tools,
    .d-print-none {
      display: none !important;
    }

    .stat-tile,
    .competitive-card,
    .samples-card,
    .charts-grid > * {
      box-shadow: none;
      break-inside: avoid;
    }

    .competitive-card ul.expanded {
      max-height: none;
      overflow: visible;
    }
  }
`;
